import axios from 'axios';
import * as actionTypes from './types';
import { socket } from '../socket';

export const retrieveIdeas = (journeyId) => {
  return (dispatch) => {
    axios
      .get('/api/idea/journey_id/' + journeyId)
      .then((res) => {
        for (let key in res.data.milestones) {
          dispatch(
            addIdea(
              res.data.milestones[key].id,
              res.data.milestones[key].persona_id,
              res.data.milestones[key].milestone,
              res.data.milestones[key].idea_content,
              res.data.milestones[key].chosen
            )
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const deleteJourneyIdeas = (journeyId) => {
  return (dispatch) => {
    axios
      .delete('/api/idea/journey_id/' + journeyId)
      .then((result) => {})
      .catch((error) => {
        console.log(error);
      });
  };
};



/**
 * TODO: ADD IDEA [SOCKET EVENT]
 * @param {integer} journeyId : ID of the journey
 * @param {integer} personaId : ID of the persona who created the idea
 * @param {string} stageName : the stage the idea is associated with
 * @param {string} ideaContent : the content the ideas has
 */
export const addIdeaDBOnly = (journeyId, personaId, stageName, ideaContent) => {
  return () => {
    socket.emit('onIdeaAddServer', { 
      journey_id: journeyId,
      persona_id: personaId, 
      milestone: stageName, 
      idea_content : ideaContent, 
      chosen : false
    });
  };
};



/**
 * TODO: ADD IDEA [REDUX ACTION]
 * @param {integer} id : the ID of the idea
 * @param {integer} personaId : the persona that created the idea
 * @param {string} stageName : the stage the idea is associated with
 * @param {string} ideaContent : the idea content
 * @param {boolean} chosen : if idea is chosen or not
 */
export const addIdea = (id, personaId, stageName, ideaContent, chosen) => ({
  type: actionTypes.ADD_IDEA,
  id: id,
  personaId : personaId,
  stageName: stageName,
  ideaContent: ideaContent,
  chosen: chosen,
});



/**
 * TODO: SELECT IDEA [SOCKET EVENT]
 * @param {integer} journeyId : used to query to set all milestone specific ideas to false
 * @param {string} personaId : the persona that created the idea
 * @param {string} stageName : used to query to set all milestone specific ideas to false
 * @param {integer} ideaId : set the chosen idea to true
 */
export const selectIdeaDBOnly = (journeyId, personaId, stageName, ideaId) => {
  return () => {
    socket.emit('onIdeaSelectServer', { 
      journeyId: journeyId,
      personaId: personaId,
      ideaId : ideaId, 
      milestone: stageName, 
    });  
  };
};



/**
 * TODO: SELECT IDEA [REDUX ACTION]
 * @param {string} personaId : the persona that created the idea
 * @param {string} stageName : the stage name the idea is associated with
 * @param {integer} ideaId : the ID of the idea
 * @param {boolean} chosen : idea is chosen or not
 */
export const selectIdea = (personaId, stageName, ideaId, chosen) => ({
  type: actionTypes.SELECT_IDEA,
  personaId: personaId,
  stageName: stageName,
  ideaId: ideaId,
  chosen: chosen
});



/**
 * TODO: UPDATE IDEA [SOCKET EVENT]
 * @param {string} personaId : the persona that created the idea
 * @param {integer} ideaId : ID of the idea
 * @param {string} stageName : the stage the idea is associated with
 * @param {string} ideaContent : the content of the idea
 */
export const updateIdeaDBOnly = (personaId, ideaId, stageName, ideaContent) => {
  return () => {
    socket.emit('onIdeaUpdateServer', { 
      personaId: personaId,
      ideaId: ideaId, 
      stageName: stageName,
      ideaContent : ideaContent, 
    });     
  };
};

/**
 * TODO: UPDATE IDEA [REDUX ACTION]
 * @param {string} personaId : the persona that created the idea
 * @param {*} ideaId : ID of the idea
 * @param {*} stageName : the stage the idea is associated with
 * @param {*} content : the content of the idea
 */
export const updateIdea = (personaId, ideaId, stageName, content) => ({
  type: actionTypes.UPDATE_IDEA,
  personaId,
  ideaId,
  stageName,
  content,
});


/**
 * TODO: DELETE IDEA [SOCKET EVENT]
 * @param {string} personaId : the persona that created the idea
 * @param {string} stageName : the stage the idea is associated with
 * @param {integer} ideaId : ID of the idea
 */
export const deleteIdeaDBOnly = (personaId, stageName, ideaId) => {
  return () => {
    socket.emit('onIdeaDeleteServer', {
      personaId : personaId,
      stageName: stageName, 
      ideaId: ideaId
    });
  };
};

/**
 * TODO: DELETE IDEA [REDUX ACTION]
 * @param {*} stageName : the stage the idea is associated with
 * @param {*} ideaId : ID of the idea
 */
export const deleteIdea = (stageName, ideaId) => ({
  type: actionTypes.DELETE_IDEA,
  stageName: stageName,
  ideaId: ideaId,
});